import React from 'react';
import {Box, Button, Chip, Paper, Typography} from '@mui/material';
import {getSettingsColors} from '../SettingsDesign';

export default function PlanCard({planName, price, events, overage, customDomains, months, totalNumberOfRecords, users, choosePlan, integrations, currentPlanName}) {
    const current = currentPlanName === planName;
    const features = [
        ['Events / month', events],
        ['Data retention', `${months} months`],
        ['Overage / 1,000 events', `€ ${overage}`],
        ['Integrations', integrations],
        ['Ads Manager', 'Included'],
        ['Automation', planName === 'Free' ? 'Not included' : 'Included'],
        ['Users', users],
        ['Custom domains with SSL', customDomains],
        ['Total entries', totalNumberOfRecords]
    ];
    return <Paper elevation={0} sx={{p: 2.5, minWidth: 0, height: '100%', boxSizing: 'border-box', borderRadius: '12px',
        border: '1px solid', borderColor: 'divider', bgcolor: theme => getSettingsColors(theme).inset,
        display: 'flex', flexDirection: 'column'}}>
        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, mb: 1}}>
            <Typography component="h2" sx={{fontSize: 18, fontWeight: 600}}>{planName}</Typography>
            {current ? <Chip label="Current" color="primary" size="small" variant="outlined" sx={{borderRadius: '6px', fontSize: 11}}/> : planName === 'Pro' && <Chip label="Popular" color="primary" size="small" sx={{borderRadius: '6px', fontSize: 11}}/>}
        </Box>
        <Typography sx={{fontSize: 12, color: 'text.secondary'}}>{planName === 'Free' ? 'No card required · No time limit' : 'Credit card required'}</Typography>
        <Box sx={{display: 'flex', alignItems: 'baseline', gap: 0.75, my: 2.5}}>
            <Typography sx={{fontSize: 36, fontWeight: 700, letterSpacing: '-1px'}}>€ {price}</Typography>
            <Typography sx={{fontSize: 13, color: 'text.secondary'}}>/ month</Typography>
        </Box>
        <Box component="dl" sx={{m: 0, flex: 1}}>
            {features.map(([label, value]) => <Box key={label} sx={{display: 'flex', alignItems: 'baseline', justifyContent: 'space-between',
                gap: 1, py: 1.25, borderTop: '1px solid', borderColor: 'divider'}}>
                <Typography component="dt" sx={{fontSize: 12, color: 'text.secondary', minWidth: 0}}>{label}</Typography>
                <Typography component="dd" sx={{m: 0, fontSize: 13, fontWeight: 600, flexShrink: 0}}>{value}</Typography>
            </Box>)}
        </Box>
        <Button fullWidth type="button" disabled={current} variant={!current && planName === 'Pro' ? 'contained' : 'outlined'} onClick={() => choosePlan(planName)} sx={{mt: 2.5, borderRadius: '8px', minHeight: 40, textTransform: 'none', boxShadow: 'none'}}
            aria-label={current ? `Current ${planName} plan` : `Select ${planName} plan`}>{current ? 'Current plan' : `Select ${planName}`}</Button>
    </Paper>;
}
